<template>
  <div>
    <div
      :class="{ bg_pad: bgPad === 'bg0' }"
      class="clearfix order_product"
      @click.stop="goOrderDetail(i.orderSn)"
    >
      <div class="left product_img_order">
        <img :src="item.skuPic" alt="" />
      </div>
      <div
        :class="{ border_bottom1px: pageShow }"
        class="left right_item right_item_pad"
      >
        <div class="name_mr ">
          <div
            class="name_name font12 font_weight400 colo0 font_line_2 text_left line_height_17"
          >
            {{ item.skuName }}
          </div>
          <div class="font10 font_weight400 colo055 name_spec text_left">
            规格：{{ item.skuSpec }}
          </div>
          <div class="sku_tags">
            <tags :tradeType="item.tradeType" :includeTax="item.includeTax" />
          </div>
        </div>
        <div class="font14 font_weight600 colo087 line_height_16">
          <div
            v-if="item.orderDetailLowerList && item.orderDetailLowerList.length"
            class="font9 some_tag"
          >
            分开发货
          </div>
          <div
            v-if="showPrice"
            :class="
              item.orderDetailLowerList && item.orderDetailLowerList.length
                ? 'product_price1'
                : 'product_price'
            "
          >
            {{
              item.price || item.skuNowPrice || item.skuPrice | currency(false)
            }}
          </div>
          <!-- 配送计划只有数量没有价格price_num_pad是上面的高度 -->
          <div
            :class="{ price_num_pad: !showPrice }"
            class="price_num font12 font_weight400 colo087 line_height_14 text_right"
          >
            ×{{ item.modifyNum || item.amount || item.skuAmount }}
          </div>
        </div>
      </div>
    </div>
    <!-- 组合商品显示 -->
    <div v-if="item.orderDetailLowerList && item.orderDetailLowerList.length">
      <div
        v-for="(i, index1) in item.orderDetailLowerList"
        :key="index1"
        class="order_product2"
      >
        <div class="product_img_order2">
          <img :src="i.skuPic" alt="" />
        </div>
        <div :class="{ border_bottom1px: pageShow }" class="right_item_pad">
          <!-- <div class="name_mr2"> -->
          <div
            class="name_name2 font12 font_weight400 colo055 font_line_2 text_left line_height_17"
          >
            {{ i.skuName }}
          </div>
          <!-- </div> -->
          <div class="font14 font_weight600 colo087 line_height_16 spec_2">
            <div class="font10 font_weight400 colo055 text_left">
              规格：{{ i.skuSpec }}
            </div>
            <div class="price_num font12 font_weight400 colo055 line_height_14">
              ×{{ i.modifyNum || i.amount || i.skuAmount }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const Tags = () => import("@/components/Tags").then(m => m.default || m);
export default {
  props: {
    listIndex: {
      type: Number,
      default: 0
    },
    pageShow: {
      type: Boolean,
      default: false
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    bgPad: {
      type: String,
      default: ""
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    i: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    Tags
  },
  data() {
    return {};
  },
  methods: {
    goOrderDetail(orderSn) {
      this.$emit("goOrderDetail", orderSn);
    }
  }
};
</script>
<style lang="less" scoped>
.order_product2 {
  margin-left: 108px;
  display: flex;
  border-top: 1px dashed rgba(0, 0, 0, 0.2);
  padding-top: 12px;
  margin-right: 18px;
  .product_img_order2 {
    width: 56px;
    height: 70px;
    img {
      width: 100%;
      max-height: 70px;
    }
  }
  .spec_2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 5px;
  }
  .right_item_pad {
    margin-left: 12px;
  }
  .name_mr2 {
    width: 100%;
  }
  // .name_name2 {
  //   max-width: 152px;
  // }
}
.some_tag {
  margin-top: 12px;
  background: rgba(83, 121, 196, 0.12);
  border: 1px solid #5379c4;
  border-radius: 2px;
  font-size: 9px;
  font-weight: 400;
  color: #5379c4;
}
.order_product {
  margin: 0 12px;
  // padding-right: 12px;
  .product_img_order {
    width: 96px;
    height: 96px;
    img {
      width: 100%;
      max-height: 96px;
    }
  }
  .right_item {
    width: 70%;
    display: flex;
    justify-content: space-between;
  }
  .right_item_pad {
    padding-bottom: 12px;
  }
  .name_mr {
    margin: 12px 0 0 12px;
    .name_name {
      width: 152px;
    }
    .name_spec {
      margin-top: 4px;
    }
    .sku_tags {
      margin-top: 6px;
    }
  }
  .product_price {
    margin-top: 29px;
  }
  .product_price1 {
    margin-top: 11px;
  }
  .price_num {
    margin-top: 8px;
  }
  .price_num_pad {
    margin-top: 30px;
  }
  .refund_status {
    color: #d91818;
    margin-top: 12px;
  }
}
.bg_pad {
  padding-right: 0 !important;
}
</style>
